import * as React from "react";

const SvgComponent = (props) => (
  <svg
    id="uuid-97a803ea-f497-43de-a29c-1d62ab08cf9a"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 5000 5000"
    {...props}
  >
    <defs></defs>
    <rect style={{ fill: "#fff" }} width="5000" height="5000" />
    <g>
      <ellipse
        style={{ fill: props.color || "#ff6f00ff" }}
        cx="2500"
        cy="1948.68"
        rx="572.32"
        ry="599.22"
      />
      <path
        style={{ fill: props.color || "#ff6f00ff" }}
        d="m4224.22,1771.55c-46.91-110.91-104.97-217.88-172.56-317.93-66.92-99.06-143.78-192.21-228.42-276.85-84.65-84.65-177.79-161.5-276.86-228.42-100.05-67.59-207.01-125.65-317.93-172.56-230.8-97.62-475.88-147.12-728.45-147.12s-497.65,49.5-728.45,147.12c-110.91,46.91-217.88,104.97-317.93,172.56-99.06,66.92-192.21,143.78-276.85,228.42-84.65,84.65-161.5,177.79-228.42,276.85-67.59,100.05-125.65,207.01-172.56,317.93-97.62,230.8-147.12,475.88-147.12,728.45s49.5,497.65,147.12,728.45c46.91,110.92,104.97,217.88,172.56,317.93,66.92,99.06,143.78,192.21,228.42,276.86,84.65,84.65,177.79,161.5,276.85,228.42,100.05,67.59,207.01,125.65,317.93,172.56,230.8,97.62,475.88,147.12,728.45,147.12s497.65-49.5,728.45-147.12c110.91-46.91,217.88-104.97,317.93-172.56,99.06-66.92,192.21-143.78,276.86-228.42,84.65-84.65,161.5-177.79,228.42-276.86,67.59-100.05,125.65-207.01,172.56-317.93,97.62-230.8,147.12-475.88,147.12-728.45s-49.5-497.65-147.12-728.45Zm-510.29,1754.63c-94.45-460.96-397.4-834.19-793.23-991.6-110.09,107.87-258.02,173.91-420.69,173.91s-310.61-66.04-420.69-173.91c-395.83,157.42-698.78,530.64-793.23,991.6-234.66-277.16-376.32-635.44-376.32-1026.18,0-876.86,713.38-1590.24,1590.24-1590.24s1590.24,713.38,1590.24,1590.24c0,390.74-141.66,749.02-376.32,1026.18Z"
      />
    </g>
  </svg>
);

export default SvgComponent;
